const initState = {
  properties: [],
  loading: false,
  error: false,
  resetProperties: [],
  pageProperties: []
};
export default initState;
